module.exports = __webpack_public_path__ + "img/noData.2feaacd9.png";